<template>
  <div :class="device.desktop ? `pmt pa-6` : `pmt pa-2`">
    <!-- Panel utama -->
    <div class="pmt-panel">
      <div class="pmt-panel-header">
        <v-icon
          small
          color="#60a5fa"
          class="mr-2"
        >mdi-monitor-eye</v-icon>
        <span class="pmt-panel-title">PEMANTAUAN CCTV</span>
        <span class="pmt-panel-count">{{ filterItems.length }} kamera</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Cari nama, wilayah, alamat..."
          single-line
          hide-details
          solo
          dense
          dark
          flat
          background-color="#0a1224"
          color="#60a5fa"
          class="pmt-search"
          :style="device.desktop ? `max-width: 320px` : ``"
        ></v-text-field>
        <v-tooltip
          bottom
          color="#1d4ed8"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              class="ml-2"
              v-on="on"
              @click="fetchRecords"
            >
              <v-icon color="#94a3b8">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Muat Ulang Data</span>
        </v-tooltip>
      </div>

      <!-- Filter -->
      <div class="pmt-filters">
        <v-select
          v-model="filterArea"
          :items="areaFilterOptions"
          label="Area"
          dense
          solo
          flat
          dark
          hide-details
          clearable
          background-color="#0a1224"
          color="#60a5fa"
          prepend-inner-icon="mdi-map-marker-radius-outline"
          class="pmt-filter-field"
          placeholder="Semua Area"
        ></v-select>
        <v-select
          v-model="filterKategori"
          :items="kategoriFilterOptions"
          label="Kategori Wilayah"
          dense
          solo
          flat
          dark
          hide-details
          clearable
          background-color="#0a1224"
          color="#60a5fa"
          prepend-inner-icon="mdi-map-legend"
          class="pmt-filter-field"
          placeholder="Semua Kategori"
        ></v-select>
        <v-select
          v-model="filterStatus"
          :items="statusFilterOptions"
          label="Status"
          dense
          solo
          flat
          dark
          hide-details
          clearable
          background-color="#0a1224"
          color="#60a5fa"
          prepend-inner-icon="mdi-access-point"
          class="pmt-filter-field"
          placeholder="Semua Status"
        ></v-select>
        <v-btn
          v-if="hasActiveFilters"
          text
          small
          dark
          color="#94a3b8"
          class="pmt-filter-reset"
          @click="resetFilters"
        >
          <v-icon
            left
            x-small
          >mdi-filter-off-outline</v-icon>
          Reset
        </v-btn>
      </div>

      <!-- Tab daftar / peta -->
      <v-tabs
        v-model="tab"
        background-color="#0d1730"
        dark
        color="#60a5fa"
        height="44"
        slider-color="#3b82f6"
        class="pmt-tabs"
      >
        <v-tab>
          <v-icon
            small
            left
          >mdi-view-grid-outline</v-icon>
          Daftar CCTV
        </v-tab>
        <v-tab>
          <v-icon
            small
            left
          >mdi-map-outline</v-icon>
          Peta Sebaran
        </v-tab>
        <v-tab>
          <v-icon
            small
            left
          >mdi-view-grid-outline</v-icon>
          Tampilan Penuh
        </v-tab>
      </v-tabs>

      <v-progress-linear
        v-show="loading.table"
        color="#3b82f6"
        height="2"
        indeterminate
      ></v-progress-linear>

      <!-- Grid kartu CCTV -->
      <div
        class="pmt-grid-wrap"
        v-show="tab === 0"
      >
        <v-row
          class="ma-0"
          v-if="filterItems.length"
        >
          <v-col
            :cols="device.desktop ? 4 : 12"
            class="pa-2"
            v-for="item in filterItems"
            :key="item.id"
          >
            <div class="pmt-card">
              <!-- Thumbnail -->
              <div
                class="pmt-thumb"
                @click="openVideo(item)"
              >
                <img
                  v-if="thumbSrc(item)"
                  :src="thumbSrc(item)"
                  class="pmt-thumb-img"
                  alt=""
                  @error="onThumbError(item.id)"
                />
                <div
                  v-else
                  class="pmt-thumb-placeholder"
                >
                  <v-icon
                    size="42"
                    color="#334155"
                  >mdi-cctv</v-icon>
                </div>

                <!-- Badge status -->
                <div
                  class="pmt-badge-status"
                  :class="item.kondisi === 'baik' ? `pmt-badge-status--on` : `pmt-badge-status--off`"
                >
                  <span class="pmt-badge-dot"></span>
                  {{ item.kondisi === "baik" ? "ONLINE" : "OFFLINE" }}
                </div>

                <!-- Badge akses publik -->
                <div class="pmt-badge-access">
                  <v-icon
                    x-small
                    :color="item.public_access && item.public_access.text === 'AKTIF' ? `#34d399` : `#94a3b8`"
                  >{{ item.public_access && item.public_access.text === "AKTIF" ? "mdi-earth" : "mdi-lock-outline" }}</v-icon>
                  {{ item.public_access && item.public_access.text === "AKTIF" ? "Publik" : "Privat" }}
                </div>

                <!-- Overlay play -->
                <div class="pmt-thumb-overlay">
                  <div class="pmt-play-btn">
                    <v-icon
                      size="28"
                      color="white"
                    >mdi-play</v-icon>
                  </div>
                </div>
              </div>

              <!-- Info -->
              <div class="pmt-card-body">
                <div class="pmt-card-name">{{ item.name }}</div>
                <div class="pmt-card-row">
                  <v-icon
                    x-small
                    color="#60a5fa"
                  >mdi-map-marker-radius-outline</v-icon>
                  <span class="pmt-card-area">{{ item.area }}</span>
                </div>
                <div
                  class="pmt-card-row"
                  v-if="item.kategori_wilayah && item.kategori_wilayah !== '-'"
                >
                  <v-icon
                    x-small
                    color="#93c5fd"
                  >mdi-map-legend</v-icon>
                  <span class="pmt-card-area">{{ item.kategori_wilayah }}</span>
                </div>
                <div class="pmt-card-row">
                  <v-icon
                    x-small
                    color="#64748b"
                  >mdi-map-marker-outline</v-icon>
                  <span class="pmt-card-address">{{ item.address || "Alamat belum diisi" }}</span>
                </div>
                <div
                  class="pmt-card-row"
                  v-if="item.contact_person"
                >
                  <v-icon
                    x-small
                    color="#64748b"
                  >mdi-account-outline</v-icon>
                  <span class="pmt-card-address">
                    {{ item.contact_person }}<template v-if="item.phone"> &middot; {{ item.phone }}</template>
                  </span>
                </div>
              </div>

              <!-- Aksi -->
              <div class="pmt-card-actions">
                <v-btn
                  small
                  depressed
                  dark
                  class="pmt-btn-watch"
                  @click="openVideo(item)"
                >
                  <v-icon
                    left
                    small
                  >mdi-play-circle-outline</v-icon>
                  Pantau
                </v-btn>
                <v-spacer></v-spacer>
                <template v-if="canManageCctv">
                  <v-tooltip
                    bottom
                    color="#1d4ed8"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        v-on="on"
                        @click="editRecord(item.id)"
                      >
                        <v-icon
                          small
                          color="#fbbf24"
                        >mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Ubah Data</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    color="#b91c1c"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        v-on="on"
                        @click="postDeleteRecord(item.id)"
                      >
                        <v-icon
                          small
                          color="#f87171"
                        >mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Hapus Data</span>
                  </v-tooltip>
                </template>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Empty state -->
        <div
          class="pmt-empty"
          v-if="!loading.table && !filterItems.length"
        >
          <v-icon
            size="56"
            color="#334155"
          >mdi-cctv-off</v-icon>
          <div class="pmt-empty-title">
            {{ hasActiveFilters || search ? "Tidak ada kamera yang cocok" : "Belum ada data CCTV" }}
          </div>
          <div class="pmt-empty-note">
            {{
              hasActiveFilters || search
                ? "Coba ubah filter atau kata kunci pencarian"
                : "Tambahkan kamera melalui menu Master Data CCTV"
            }}
          </div>
        </div>
      </div>

      <!-- Peta sebaran CCTV -->
      <div
        class="pmt-map-wrap"
        v-if="tab === 1"
      >
        <l-map
          :style="device.desktop ? `height: 560px; z-index: 0;` : `height: 420px; z-index: 0;`"
          :zoom="zoom"
          :center="center"
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          ></l-tile-layer>
          <l-marker
            v-for="item in mapMarkers"
            :key="item.id"
            :lat-lng="item.position"
            @click="openVideo(item)"
          >
            <l-icon
              :icon-url="markerIcon(item)"
              :icon-size="[36, 48]"
              :icon-anchor="[18, 46]"
              :popup-anchor="[0, -40]"
            />
            <l-tooltip :content="markerTooltip(item)" />
          </l-marker>
        </l-map>

        <div class="pmt-map-footer">
          <div class="pmt-map-stat">
            <v-icon
              small
              color="#93c5fd"
            >mdi-cctv</v-icon>
            <span>Total <b>{{ mapMarkers.length }}</b> titik</span>
          </div>
          <div class="pmt-map-stat">
            <span class="pmt-badge-dot pmt-dot-on"></span>
            <span>Online <b>{{ countOnline }}</b></span>
          </div>
          <div class="pmt-map-stat">
            <span class="pmt-badge-dot pmt-dot-off"></span>
            <span>Offline <b>{{ countOffline }}</b></span>
          </div>
          <v-spacer></v-spacer>
          <div class="pmt-map-note">
            <v-icon
              x-small
              color="#94a3b8"
            >mdi-cursor-default-click-outline</v-icon>
            Klik penanda pada peta untuk memantau kamera
          </div>
        </div>
      </div>

      <!-- Tampilan penuh: 9 CCTV live sekaligus -->
      <div
        class="pmt-wall-wrap"
        ref="wallWrap"
        v-if="tab === 2"
      >
        <div class="pmt-wall-toolbar">
          <v-spacer></v-spacer>
          <v-tooltip
            bottom
            color="#1d4ed8"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                dark
                v-on="on"
                @click="toggleWallFullscreen"
              >
                <v-icon color="#94a3b8">{{ isWallFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen" }}</v-icon>
              </v-btn>
            </template>
            <span>{{ isWallFullscreen ? "Keluar Layar Penuh" : "Layar Penuh" }}</span>
          </v-tooltip>
        </div>

        <v-row
          class="ma-0"
          v-if="wallPagedItems.length"
        >
          <v-col
            :cols="device.desktop ? 4 : 12"
            class="pa-2"
            v-for="item in wallPagedItems"
            :key="'wall-' + item.id"
          >
            <div class="pmt-wall-tile">
              <div class="pmt-wall-tile-header">
                <span
                  class="pmt-badge-dot"
                  :class="item.kondisi === 'baik' ? `pmt-dot-on` : `pmt-dot-off`"
                ></span>
                <span
                  class="pmt-wall-tile-name"
                  :title="item.name"
                >{{ item.name }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  x-small
                  @click="openVideo(item)"
                >
                  <v-icon
                    x-small
                    color="#94a3b8"
                  >mdi-fullscreen</v-icon>
                </v-btn>
              </div>
              <div class="pmt-wall-video-wrap">
                <video
                  :ref="'wallVideo-' + item.id"
                  class="pmt-wall-video"
                  controls
                  autoplay
                  muted
                  playsinline
                ></video>
                <div
                  class="pmt-wall-overlay"
                  v-show="wallStatus[item.id] && wallStatus[item.id].loading"
                >
                  <v-progress-circular
                    indeterminate
                    size="26"
                    width="2"
                    color="#60a5fa"
                  ></v-progress-circular>
                </div>
                <div
                  class="pmt-wall-overlay"
                  v-show="wallStatus[item.id] && wallStatus[item.id].error"
                >
                  <v-icon
                    size="26"
                    color="#f87171"
                  >mdi-video-off-outline</v-icon>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <div
          class="pmt-empty"
          v-if="!loading.table && !wallPagedItems.length"
        >
          <v-icon
            size="56"
            color="#334155"
          >mdi-cctv-off</v-icon>
          <div class="pmt-empty-title">Belum ada kamera untuk ditampilkan</div>
        </div>

        <div
          class="pmt-wall-pagination"
          v-if="wallTotalPages > 1"
        >
          <v-btn
            icon
            small
            dark
            :disabled="wallPage <= 1"
            @click="prevWallPage"
          >
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="pmt-wall-pagination-label">Halaman {{ wallPage }} / {{ wallTotalPages }}</span>
          <v-btn
            icon
            small
            dark
            :disabled="wallPage >= wallTotalPages"
            @click="nextWallPage"
          >
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Dialog ubah data -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      v-if="canManageCctv"
      :max-width="device.desktop ? `560px` : `100%`"
      persistent
      :fullscreen="device.mobile"
    >
      <v-card
        color="#101b36"
        dark
        class="pmt-dialog"
      >
        <div class="pmt-dialog-header">
          <v-icon
            small
            color="#fbbf24"
            class="mr-2"
          >mdi-pencil-circle-outline</v-icon>
          <span class="pmt-panel-title">UBAH DATA KAMERA</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="closeForm"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pmt-dialog-body">
          <div class="pmt-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-cctv</v-icon>
            Informasi Kamera
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                outlined
                dark
                dense
                color="#60a5fa"
                background-color="#0a1224"
                label="Nama Kamera"
                v-model="record.name"
                persistent-hint
                hint="Nama lokasi pemasangan kamera"
                prepend-inner-icon="mdi-cctv"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-select
                label="Area"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                persistent-hint
                hint="Wilayah/kecamatan lokasi kamera"
                v-model="record.area_uuid"
                :items="areas"
                prepend-inner-icon="mdi-map-marker-radius-outline"
              />
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-select
                label="Kategori Wilayah"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                persistent-hint
                hint="Kategori pengelompokan wilayah kamera"
                v-model="record.kategori_wilayah_uuid"
                :items="kategoriWilayahs"
                clearable
                prepend-inner-icon="mdi-map-legend"
              />
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-select
                label="Kondisi"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                persistent-hint
                hint="Kondisi fisik kamera saat ini"
                v-model="record.status"
                :items="status"
                prepend-inner-icon="mdi-stethoscope"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                dark
                dense
                rows="2"
                color="#60a5fa"
                background-color="#0a1224"
                label="Alamat"
                v-model="record.address"
                persistent-hint
                hint="Alamat lengkap titik pemasangan"
                prepend-inner-icon="mdi-map-marker-outline"
              ></v-textarea>
            </v-col>
          </v-row>

          <div class="pmt-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-card-account-phone-outline</v-icon>
            Kontak &amp; Perangkat
          </div>
          <v-row dense>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                outlined
                dark
                dense
                color="#60a5fa"
                background-color="#0a1224"
                label="Penanggung Jawab"
                v-model="record.contact_person"
                persistent-hint
                hint="Nama petugas penanggung jawab"
                prepend-inner-icon="mdi-account-outline"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                outlined
                dark
                dense
                color="#60a5fa"
                background-color="#0a1224"
                label="No. Telepon"
                v-model="record.phone"
                persistent-hint
                hint="Nomor yang dapat dihubungi"
                prepend-inner-icon="mdi-phone-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dark
                dense
                color="#60a5fa"
                background-color="#0a1224"
                label="URL RTSP"
                v-model="record.url"
                persistent-hint
                hint="Alamat streaming RTSP kamera"
                prepend-inner-icon="mdi-link-variant"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="pmt-access">
            <v-switch
              label="Dapat diakses oleh publik"
              color="#3b82f6"
              dark
              v-model="record.public_access"
              hide-details
              class="mt-0"
            ></v-switch>
            <div class="pmt-access-note">
              Jika aktif, kamera ini dapat dilihat masyarakat pada halaman depan
            </div>
          </div>

          <div class="pmt-form-note">
            <v-icon
              x-small
              color="#94a3b8"
            >mdi-information-outline</v-icon>
            Foto &amp; titik koordinat dapat diubah melalui menu Master Data CCTV
          </div>
        </v-card-text>

        <v-divider class="pmt-dialog-divider"></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn
            text
            color="#94a3b8"
            @click="closeForm"
          >Batal</v-btn>
          <v-btn
            depressed
            dark
            class="pmt-btn-watch"
            @click="postUpdateRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog pantau video -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="video.dialog"
      :max-width="device.desktop ? `760px` : `100%`"
      persistent
      eager
      :fullscreen="device.mobile"
    >
      <v-card
        color="#101b36"
        dark
        class="pmt-dialog"
      >
        <div class="pmt-dialog-header">
          <span class="pmt-live-dot"></span>
          <span class="pmt-panel-title">{{ video.name || "PANTAU CCTV" }}</span>
          <span
            class="pmt-panel-count"
            v-if="video.area"
          >{{ video.area }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="stopVideo"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="pmt-video-wrap">
          <video
            ref="videoEl"
            class="pmt-video"
            controls
            autoplay
            muted
            playsinline
          ></video>

          <div class="pmt-video-watermark">
            <div class="pmt-video-watermark-logos">
              <img
                src="/images/logo-kab.png"
                alt=""
                aria-hidden="true"
              />
              <img
                src="/images/logo-diskominfo-kabtangerang.jpeg"
                alt=""
                aria-hidden="true"
              />
            </div>
            <div class="pmt-video-watermark-text">
              Sistem Pemantauan CCTV Kab. Tangerang
            </div>
          </div>

          <div
            class="pmt-video-overlay"
            v-show="video.loading"
          >
            <v-progress-circular
              indeterminate
              color="#60a5fa"
              size="44"
            ></v-progress-circular>
            <span>Menghubungkan ke kamera...</span>
          </div>

          <div
            class="pmt-video-overlay"
            v-show="video.error"
          >
            <v-icon
              size="44"
              color="#f87171"
            >mdi-video-off-outline</v-icon>
            <span>Stream tidak tersedia, kamera mungkin offline</span>
          </div>

          <div
            class="pmt-video-overlay pmt-video-overlay--limit"
            v-show="video.limitPaused"
          >
            <v-btn
              depressed
              dark
              class="pmt-btn-watch mt-2"
              @click="continueWatch"
            >
              <v-icon
                left
                small
              >mdi-play</v-icon>
              Continue
            </v-btn>
          </div>

          <div
            class="pmt-watch-timer"
            v-if="video.dialog && !video.loading && !video.error"
          >
            <v-icon
              x-small
              color="#93c5fd"
            >mdi-timer-outline</v-icon>
            {{ watchRemainLabel }}
          </div>
        </div>

        <v-divider class="pmt-dialog-divider"></v-divider>
        <v-card-actions class="pa-4">
          <div
            class="pmt-form-note"
            v-if="video.address"
          >
            <v-icon
              x-small
              color="#94a3b8"
            >mdi-map-marker-outline</v-icon>
            {{ video.address }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="#94a3b8"
            @click="stopVideo"
          >Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import "animate.css";
import Hls from "hls.js";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LTooltip,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "pemantauan-cctv",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip,
  },
  data: () => ({
    search: null,
    tab: 0,
    filterArea: null,
    filterKategori: null,
    filterStatus: null,
    statusFilterOptions: [
      { text: "Online", value: "baik" },
      { text: "Offline", value: "rusak" },
    ],

    //map property (dark tiles agar serasi dengan tema)
    url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    attribution:
      '&copy; <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a target="_blank" href="https://carto.com/attributions">CARTO</a>',
    zoom: 11,
    center: [-6.2204, 106.4675],
    areas: [],
    kategoriWilayahs: [],
    status: [
      { text: "Baik", value: "baik" },
      { text: "Rusak", value: "rusak" },
    ],
    video: {
      dialog: false,
      id: null,
      name: null,
      area: null,
      address: null,
      loading: false,
      error: false,
      limitPaused: false,
    },
    player: null,
    watchLimitMs: 5 * 60 * 1000,
    watchRemainMs: 5 * 60 * 1000,
    watchLimitTimer: null,
    watchTickTimer: null,
    captureUploadInFlight: {},
    brokenThumbs: {},

    //tampilan penuh (9 CCTV sekaligus)
    wallPage: 1,
    wallPageSize: 9,
    wallPlayers: {},
    wallStatus: {},
    isWallFullscreen: false,
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "form",
      "table",
      "user",
    ]),
    watchRemainLabel() {
      if (this.video.limitPaused) return "Dijeda";
      const total = Math.max(0, Math.ceil(this.watchRemainMs / 1000));
      const m = Math.floor(total / 60);
      const s = String(total % 60).padStart(2, "0");
      return `${m}:${s}`;
    },
    canManageCctv() {
      const role = (this.user && this.user.authent) || "";
      return role !== "operator";
    },
    areaFilterOptions() {
      return (this.areas || []).map((item) => ({
        text: item.text,
        value: item.text,
      }));
    },
    kategoriFilterOptions() {
      return (this.kategoriWilayahs || []).map((item) => ({
        text: item.text,
        value: item.text,
      }));
    },
    hasActiveFilters() {
      return !!(this.filterArea || this.filterKategori || this.filterStatus);
    },
    filterItems() {
      let items = this.records || [];

      if (this.filterArea) {
        items = items.filter((item) => item.area === this.filterArea);
      }
      if (this.filterKategori) {
        items = items.filter(
          (item) => item.kategori_wilayah === this.filterKategori
        );
      }
      if (this.filterStatus) {
        items = items.filter((item) => {
          if (this.filterStatus === "baik") return item.kondisi === "baik";
          return item.kondisi !== "baik";
        });
      }
      if (this.search) {
        const q = this.search.toLowerCase();
        items = items.filter((item) => {
          return (
            (item.name || "").toLowerCase().indexOf(q) > -1 ||
            (item.area || "").toLowerCase().indexOf(q) > -1 ||
            (item.kategori_wilayah || "").toLowerCase().indexOf(q) > -1 ||
            (item.address || "").toLowerCase().indexOf(q) > -1
          );
        });
      }
      return items;
    },
    mapMarkers() {
      return this.filterItems
        .filter((item) => item.lat && item.lng)
        .map((item) => ({
          ...item,
          position: {
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lng),
          },
        }));
    },
    countOnline() {
      return this.filterItems.filter((item) => item.kondisi === "baik").length;
    },
    countOffline() {
      return this.filterItems.filter((item) => item.kondisi !== "baik").length;
    },
    wallTotalPages() {
      return Math.max(
        1,
        Math.ceil(this.filterItems.length / this.wallPageSize)
      );
    },
    wallPagedItems() {
      const start = (this.wallPage - 1) * this.wallPageSize;
      return this.filterItems.slice(start, start + this.wallPageSize);
    },
  },
  watch: {
    tab(val, oldVal) {
      if (val === 1) {
        this.$nextTick(() => {
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 250);
        });
      }
      if (oldVal === 2 && val !== 2) {
        this.destroyWallPlayers();
      }
      if (val === 2) {
        this.$nextTick(() => {
          this.initWallPlayers();
        });
      }
    },
    wallPage() {
      this.destroyWallPlayers();
      this.$nextTick(() => {
        this.initWallPlayers();
      });
    },
    wallTotalPages(val) {
      if (this.wallPage > val) {
        this.wallPage = val;
      }
    },
    filterItems() {
      if (this.tab !== 2) return;
      if (this.wallPage !== 1) {
        this.wallPage = 1;
        return;
      }
      this.destroyWallPlayers();
      this.$nextTick(() => {
        this.initWallPlayers();
      });
    },
  },
  created() {
    const isOperator =
      this.user && this.user.authent === "operator";
    this.setPage({
      crud: true,
      dataUrl: "api/superadmin/master-data/cctv",
      pagination: false,
      title: "PEMANTAUAN CCTV",
      subtitle: "Berikut Daftar Seluruh Pemantauan CCTV Yang Tersedia",
      showtable: true,
      breadcrumbs: [
        {
          text: "PEMANTAUAN",
          disabled: true,
          href: "",
        },
        {
          text: "CCTV",
          disabled: false,
          href: "",
        },
      ],
      actions: {
        refresh: true,
        add: false,
        edit: !isOperator,
        delete: !isOperator,
        bulkdelete: false,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
    this.fetchAreas();
    this.fetchKategoriWilayahs();
  },
  mounted() {
    document.addEventListener(
      "fullscreenchange",
      this.handleWallFullscreenChange
    );
  },
  beforeDestroy() {
    if (this.video.dialog && this.video.id) {
      this.captureLastFrame();
    }
    this.clearWatchLimit();
    this.destroyPlayer();
    this.destroyWallPlayers();
    document.removeEventListener(
      "fullscreenchange",
      this.handleWallFullscreenChange
    );
  },
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "setLoading",
      "setRecord",
      "setForm",
    ]),
    fetchAreas: async function () {
      try {
        let { data } = await this.http.get("api/combo/area");
        this.areas = data;
      } catch (error) {}
    },
    fetchKategoriWilayahs: async function () {
      try {
        let { data } = await this.http.get("api/combo/kategori-wilayah");
        this.kategoriWilayahs = data;
      } catch (error) {}
    },
    resetFilters: function () {
      this.filterArea = null;
      this.filterKategori = null;
      this.filterStatus = null;
      this.search = null;
    },
    markerTooltip: function (item) {
      const status =
        item.kondisi === "baik"
          ? "<span style='color:#34d399'><b>ONLINE</b></span>"
          : "<span style='color:#f87171'><b>OFFLINE</b></span>";
      return (
        "<b>" +
        item.name +
        "</b><br/>" +
        item.area +
        "<br/>" +
        (item.address || "") +
        "<br/>Status : " +
        status
      );
    },
    markerIcon: function (item) {
      return item && item.kondisi === "baik"
        ? "/images/cctv-marker-online.svg"
        : "/images/cctv-marker-offline.svg";
    },
    fotoSrc: function (foto) {
      if (!foto) return null;
      const raw = String(foto).trim();
      if (/^https?:\/\//.test(raw) || raw.startsWith("data:")) return raw;

      const base = (
        (this.http && this.http.defaults && this.http.defaults.baseURL) ||
        ""
      ).replace(/\/$/, "");
      const origin = base.replace(/\/api$/i, "") || (typeof window !== "undefined" ? window.location.origin : "");
      const [pathPart, query] = raw.split("?");
      const q = query ? `?${query}` : "";

      if (pathPart.startsWith("/images/") || pathPart.startsWith("images/")) {
        const p = pathPart.startsWith("/") ? pathPart : `/${pathPart}`;
        return `${origin}${p}${q}`;
      }
      if (pathPart.startsWith("/")) return `${origin}${pathPart}${q}`;
      if (pathPart.startsWith("storage/")) {
        return `${base}/api/${pathPart}${q}`;
      }
      return null;
    },
    onThumbError: function (id) {
      if (!id) return;
      this.$set(this.brokenThumbs, id, true);
    },
    thumbSrc: function (item) {
      if (!item || this.brokenThumbs[item.id]) return null;
      return this.fotoSrc(item.foto);
    },

    /** form ubah data */
    editRecord: function (val) {
      if (!this.canManageCctv) return;
      this.postEdit(val);
      this.setForm({
        add: true,
        edit: true,
      });
    },
    closeForm: function () {
      this.setForm({
        add: false,
        edit: false,
      });
    },
    postUpdateRecord: function () {
      if (!this.canManageCctv) return;
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord: function (val) {
      if (!this.canManageCctv) return;
      this.postConfirmDelete(val);
    },

    /** pantau video (HLS) */
    openVideo: function (item) {
      this.video.id = item.id;
      this.video.name = item.name;
      this.video.area = item.area;
      this.video.address = item.address;
      this.video.loading = true;
      this.video.error = false;
      this.video.limitPaused = false;
      this.video.dialog = true;

      this.$nextTick(() => {
        this.initPlayer(item.id);
      });
    },
    clearWatchLimit: function () {
      if (this.watchLimitTimer) {
        clearTimeout(this.watchLimitTimer);
        this.watchLimitTimer = null;
      }
      if (this.watchTickTimer) {
        clearInterval(this.watchTickTimer);
        this.watchTickTimer = null;
      }
    },
    startWatchLimit: function () {
      this.clearWatchLimit();
      this.video.limitPaused = false;
      this.watchRemainMs = this.watchLimitMs;
      const startedAt = Date.now();
      this.watchTickTimer = setInterval(() => {
        this.watchRemainMs = Math.max(
          0,
          this.watchLimitMs - (Date.now() - startedAt)
        );
      }, 250);
      this.watchLimitTimer = setTimeout(() => {
        this.onWatchLimitReached();
      }, this.watchLimitMs);
    },
    onWatchLimitReached: function () {
      this.clearWatchLimit();
      this.watchRemainMs = 0;
      this.video.limitPaused = true;
      const videoEl = this.$refs.videoEl;
      if (videoEl) {
        videoEl.pause();
        videoEl.controls = false;
      }
    },
    continueWatch: function () {
      this.video.limitPaused = false;
      const videoEl = this.$refs.videoEl;
      if (videoEl) {
        videoEl.controls = true;
        videoEl.play().catch(() => {});
      }
      this.startWatchLimit();
    },
    initPlayer: function (id) {
      this.destroyPlayer();

      const videoEl = this.$refs.videoEl;
      if (!videoEl) return;

      const base = (
        (this.http && this.http.defaults && this.http.defaults.baseURL) ||
        ""
      ).replace(/\/$/, "");
      const streamUrl = `${base}/api/stream-cctv/${encodeURIComponent(
        id
      )}/index.m3u8`;

      if (Hls.isSupported()) {
        this.player = new Hls();
        this.player.loadSource(streamUrl);
        this.player.attachMedia(videoEl);
        this.player.on(Hls.Events.MANIFEST_PARSED, () => {
          this.video.loading = false;
          videoEl.play().catch(() => {});
          this.startWatchLimit();
        });
        this.player.on(Hls.Events.ERROR, (_event, data) => {
          if (data.fatal) {
            this.video.loading = false;
            this.video.error = true;
            this.destroyPlayer();
          }
        });
      } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
        videoEl.src = streamUrl;
        videoEl.addEventListener(
          "loadedmetadata",
          () => {
            this.video.loading = false;
            videoEl.play().catch(() => {});
            this.startWatchLimit();
          },
          { once: true }
        );
        videoEl.addEventListener(
          "error",
          () => {
            this.video.loading = false;
            this.video.error = true;
          },
          { once: true }
        );
      } else {
        this.video.loading = false;
        this.video.error = true;
      }
    },
    captureEndpoints: function (itemId) {
      const baseURL =
        (this.http && this.http.defaults && this.http.defaults.baseURL) || "";
      const normalizedBase = String(baseURL).replace(/\/$/, "");
      const path = `/stream-cctv/${encodeURIComponent(itemId)}/capture`;
      const urls = [];
      const push = (u) => {
        if (u && urls.indexOf(u) === -1) urls.push(u);
      };
      const origin =
        typeof window !== "undefined" ? window.location.origin : "";

      if (normalizedBase) {
        push(`${normalizedBase}${path}`);
        const sansApi = normalizedBase.replace(/\/api$/i, "");
        push(`${sansApi}${path}`);
        push(`${sansApi}/api${path}`);
      }
      push(`${origin}/api${path}`);
      push(`${origin}${path}`);
      return urls;
    },
    uploadCaptureToBackend: async function (itemId, imageData) {
      if (!itemId || !imageData) return;
      if (this.captureUploadInFlight[itemId]) return;

      this.$set(this.captureUploadInFlight, itemId, true);
      try {
        for (const endpoint of this.captureEndpoints(itemId)) {
          try {
            const resp = await fetch(endpoint, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ image: imageData }),
            });
            if (resp.ok) {
              let stored = `images/cctv-captures/${itemId}.jpg?t=${Date.now()}`;
              try {
                const body = await resp.json();
                const foto =
                  body &&
                  body.response &&
                  body.response.data &&
                  body.response.data.foto;
                if (foto) stored = `${foto}?t=${Date.now()}`;
              } catch (e) {}
              this.$store.commit("CHANGE_RECORDS_MUTATION", {
                id: itemId,
                foto: stored,
              });
              this.$delete(this.brokenThumbs, itemId);
              break;
            }
          } catch (e) {}
        }
      } finally {
        this.$set(this.captureUploadInFlight, itemId, false);
      }
    },
    captureLastFrame: function () {
      const itemId = this.video.id;
      const video = this.$refs.videoEl;
      if (
        !itemId ||
        !video ||
        video.readyState < 2 ||
        !video.videoWidth ||
        !video.videoHeight
      ) {
        return;
      }

      try {
        const maxWidth = 640;
        const scale = Math.min(1, maxWidth / video.videoWidth);
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.floor(video.videoWidth * scale));
        canvas.height = Math.max(1, Math.floor(video.videoHeight * scale));
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL("image/jpeg", 0.65);
        // Preview segera di kartu sebelum upload selesai.
        this.$store.commit("CHANGE_RECORDS_MUTATION", {
          id: itemId,
          foto: dataUrl,
        });
        this.$delete(this.brokenThumbs, itemId);
        this.uploadCaptureToBackend(itemId, dataUrl);
      } catch (e) {}
    },
    destroyPlayer: function () {
      this.clearWatchLimit();
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }
      const videoEl = this.$refs.videoEl;
      if (videoEl) {
        videoEl.pause();
        videoEl.removeAttribute("src");
        videoEl.load();
      }
    },
    stopVideo: function () {
      // Sama seperti halaman depan: simpan cuplikan terakhir sebelum player dihancurkan.
      this.captureLastFrame();
      this.destroyPlayer();
      this.video.dialog = false;
      this.video.loading = false;
      this.video.error = false;
      this.video.limitPaused = false;
    },

    /** tampilan penuh (9 CCTV sekaligus, HLS multi-player) */
    initWallPlayers: function () {
      if (this.tab !== 2) return;
      this.wallPagedItems.forEach((item) => {
        this.initWallPlayer(item);
      });
    },
    initWallPlayer: function (item) {
      const refs = this.$refs["wallVideo-" + item.id];
      const videoEl = Array.isArray(refs) ? refs[0] : refs;
      if (!videoEl) return;

      this.$set(this.wallStatus, item.id, { loading: true, error: false });

      const base = (
        (this.http && this.http.defaults && this.http.defaults.baseURL) ||
        ""
      ).replace(/\/$/, "");
      const streamUrl = `${base}/api/stream-cctv/${encodeURIComponent(
        item.id
      )}/index.m3u8`;

      if (Hls.isSupported()) {
        const hls = new Hls();
        this.wallPlayers[item.id] = hls;
        hls.loadSource(streamUrl);
        hls.attachMedia(videoEl);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$set(this.wallStatus, item.id, { loading: false, error: false });
          videoEl.play().catch(() => {});
        });
        hls.on(Hls.Events.ERROR, (_event, data) => {
          if (data.fatal) {
            this.$set(this.wallStatus, item.id, { loading: false, error: true });
            this.destroyWallPlayer(item.id);
          }
        });
      } else if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
        videoEl.src = streamUrl;
        videoEl.addEventListener(
          "loadedmetadata",
          () => {
            this.$set(this.wallStatus, item.id, { loading: false, error: false });
            videoEl.play().catch(() => {});
          },
          { once: true }
        );
        videoEl.addEventListener(
          "error",
          () => {
            this.$set(this.wallStatus, item.id, { loading: false, error: true });
          },
          { once: true }
        );
      } else {
        this.$set(this.wallStatus, item.id, { loading: false, error: true });
      }
    },
    destroyWallPlayer: function (id) {
      const hls = this.wallPlayers[id];
      if (hls) {
        hls.destroy();
        delete this.wallPlayers[id];
      }
      const refs = this.$refs["wallVideo-" + id];
      const videoEl = Array.isArray(refs) ? refs[0] : refs;
      if (videoEl) {
        videoEl.pause();
        videoEl.removeAttribute("src");
        videoEl.load();
      }
    },
    destroyWallPlayers: function () {
      Object.keys(this.wallPlayers).forEach((id) => {
        this.destroyWallPlayer(id);
      });
    },
    nextWallPage: function () {
      if (this.wallPage < this.wallTotalPages) {
        this.wallPage += 1;
      }
    },
    prevWallPage: function () {
      if (this.wallPage > 1) {
        this.wallPage -= 1;
      }
    },
    toggleWallFullscreen: function () {
      if (!document.fullscreenElement) {
        const el = this.$refs.wallWrap;
        if (el && el.requestFullscreen) {
          el.requestFullscreen().catch(() => {});
        }
      } else if (document.exitFullscreen) {
        document.exitFullscreen().catch(() => {});
      }
    },
    handleWallFullscreenChange: function () {
      this.isWallFullscreen = !!(
        document.fullscreenElement && document.fullscreenElement === this.$refs.wallWrap
      );
    },
  },
};
</script>

<style scoped>
.pmt {
  min-height: 100%;
  background: #0a1224;
}

.pmt-panel {
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.pmt-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.pmt-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

.pmt-panel-count {
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
  font-size: 10px;
  font-weight: 600;
  color: #93c5fd;
  white-space: nowrap;
}

.pmt-search >>> .v-input__slot {
  border: 1px solid #1e2c4f;
  border-radius: 8px;
}

.pmt-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
  background: #0d1730;
}

.pmt-filter-field {
  flex: 1 1 180px;
  max-width: 240px;
  margin: 0;
}

.pmt-filter-field >>> .v-input__slot {
  border: 1px solid #1e2c4f;
  border-radius: 8px;
  min-height: 36px !important;
}

.pmt-filter-reset {
  letter-spacing: 0.3px;
  text-transform: none;
}

.pmt-grid-wrap {
  padding: 8px;
}

/* tabs */
.pmt-tabs {
  border-bottom: 1px solid #1e2c4f;
}

.pmt-tabs >>> .v-tab {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: none;
  color: #94a3b8 !important;
}

.pmt-tabs >>> .v-tab--active {
  color: #93c5fd !important;
}

/* peta */
.pmt-map-wrap {
  position: relative;
}

.pmt-map-footer {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 16px;
  border-top: 1px solid #1e2c4f;
  font-size: 12px;
  color: #cbd5e1;
}

.pmt-map-stat {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.pmt-map-stat b {
  color: #e2e8f0;
}

.pmt-dot-on {
  color: #34d399;
}

.pmt-dot-off {
  color: #f87171;
}

.pmt-map-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #94a3b8;
}

/* kartu cctv */
.pmt-card {
  background: #0d1730;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.pmt-card:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(2, 6, 23, 0.55);
}

.pmt-thumb {
  position: relative;
  aspect-ratio: 16 / 9;
  background: #0a1224;
  cursor: pointer;
  overflow: hidden;
}

.pmt-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.pmt-thumb-placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11px;
  color: #475569;
}

.pmt-badge-status {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: rgba(2, 6, 23, 0.72);
  backdrop-filter: blur(4px);
}

.pmt-badge-status--on {
  color: #34d399;
}

.pmt-badge-status--off {
  color: #f87171;
}

.pmt-badge-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 8px currentColor;
}

.pmt-badge-access {
  position: absolute;
  top: 10px;
  left: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  color: #cbd5e1;
  background: rgba(2, 6, 23, 0.72);
  backdrop-filter: blur(4px);
}

.pmt-thumb-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.35);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.pmt-thumb:hover .pmt-thumb-overlay {
  opacity: 1;
}

.pmt-play-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%);
  box-shadow: 0 8px 24px rgba(29, 78, 216, 0.5);
}

.pmt-card-body {
  padding: 12px 14px 6px 14px;
}

.pmt-card-name {
  font-size: 14px;
  font-weight: 700;
  color: #e2e8f0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pmt-card-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 5px;
  font-size: 11px;
  line-height: 1.4;
}

.pmt-card-area {
  font-weight: 600;
  color: #93c5fd;
}

.pmt-card-address {
  color: #94a3b8;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pmt-card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 10px 14px;
  border-top: 1px solid #16224384;
}

.pmt-btn-watch {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
}

/* empty state */
.pmt-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 60px 16px;
  text-align: center;
}

.pmt-empty-title {
  font-size: 14px;
  font-weight: 700;
  color: #cbd5e1;
}

.pmt-empty-note {
  font-size: 12px;
  color: #64748b;
}

/* dialog */
.pmt-dialog {
  border: 1px solid #1e2c4f;
}

.pmt-dialog-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #1e2c4f;
  background: #0d1730;
}

.pmt-dialog-body {
  padding-top: 16px;
}

.pmt-dialog-divider {
  border-color: #1e2c4f !important;
}

.pmt-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #93c5fd;
  margin: 14px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px dashed #1e2c4f;
}

.pmt-access {
  margin-top: 8px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
}

.pmt-access-note {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}

.pmt-form-note {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  font-size: 11px;
  color: #94a3b8;
}

/* video */
.pmt-live-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #ef4444;
  box-shadow: 0 0 10px #ef4444;
  margin-right: 10px;
  animation: pmt-pulse 1.2s ease-in-out infinite;
}

@keyframes pmt-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.pmt-video-wrap {
  position: relative;
  background: #020617;
  aspect-ratio: 16 / 9;
}

.pmt-video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  background: #020617;
}

.pmt-video-watermark {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  user-select: none;
  z-index: 2;
}

.pmt-video-watermark-logos {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pmt-video-watermark-logos img {
  width: 64px;
  height: auto;
  opacity: 0.55;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.45));
}

.pmt-video-watermark-text {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  text-align: center;
}

.pmt-video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 12px;
  color: #94a3b8;
  background: rgba(2, 6, 23, 0.78);
  z-index: 3;
}

.pmt-video-overlay--limit {
  z-index: 4;
  gap: 10px;
}

.pmt-watch-timer {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(2, 6, 23, 0.72);
  border: 1px solid #1e2c4f;
  font-size: 11px;
  font-weight: 600;
  color: #e2e8f0;
  pointer-events: none;
}

/* tampilan penuh (wall 9 cctv) */
.pmt-wall-wrap {
  padding: 8px;
  background: #0a1224;
}

.pmt-wall-toolbar {
  display: flex;
  align-items: center;
  padding: 4px 8px 0 8px;
}

.pmt-wall-tile {
  background: #0d1730;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.pmt-wall-tile-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-bottom: 1px solid #1e2c4f;
}

.pmt-wall-tile-name {
  font-size: 11px;
  font-weight: 700;
  color: #e2e8f0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pmt-wall-video-wrap {
  position: relative;
  background: #020617;
  aspect-ratio: 16 / 9;
}

.pmt-wall-video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  background: #020617;
}

.pmt-wall-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.6);
}

.pmt-wall-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 16px;
  border-top: 1px solid #1e2c4f;
}

.pmt-wall-pagination-label {
  font-size: 12px;
  font-weight: 600;
  color: #cbd5e1;
}
</style>
